(() => {
  if (window.lwSizeChartInitialized) return;
  window.lwSizeChartInitialized = true;
  const parseCSV = text => {
    text = text.replace(/^\uFEFF/, '');
    const parse = delimiter => {
      const rows = [];
      let row = [], cell = '', quoted = false, closed = false;
      const finishCell = () => { row.push(cell.trim()); cell = ''; closed = false; };
      const finishRow = () => { finishCell(); if (row.some(value => value !== '')) rows.push(row); row = []; };
      for (let i = 0; i < text.length; i++) {
        const char = text[i];
        if (quoted) {
          if (char === '"') {
            if (text[i + 1] === '"') { cell += '"'; i++; }
            else { quoted = false; closed = true; }
          } else cell += char;
        } else if (char === delimiter) finishCell();
        else if (char === '\n' || char === '\r') { finishRow(); if (char === '\r' && text[i + 1] === '\n') i++; }
        else if (char === '"' && !cell.trim() && !closed) { cell = ''; quoted = true; }
        else if (closed && char.trim()) throw new Error('Ongeldige CSV');
        else cell += char;
      }
      if (quoted) throw new Error('Ongeldige CSV');
      finishRow();
      if (rows.length < 2 || rows.length > 1001) throw new Error('CSV zonder maten');
      const width = rows[0].length;
      if (width < 2 || width > 20 || rows[0].some(cell => !cell) || rows.some(row => row.length !== width) || rows.slice(1).some(row => !row[0])) throw new Error('Ongeldige kolommen');
      return rows;
    };
    for (const delimiter of [';', ',', '\t', '|']) {
      try { return parse(delimiter); } catch (_) {}
    }
    throw new Error('Geen geldige maattabel');
  };
  const csvLoads = new Map();
  const loadCSV = url => {
    if (!csvLoads.has(url)) {
      const promise = fetch(url).then(async response => {
        if (!response.ok) throw new Error('CSV niet beschikbaar');
        const bytes = new Uint8Array(await response.arrayBuffer());
        if (bytes.length > 512000) throw new Error('CSV te groot');
        const encoding = bytes[0] === 255 && bytes[1] === 254 ? 'utf-16le' : bytes[0] === 254 && bytes[1] === 255 ? 'utf-16be' : 'utf-8';
        return parseCSV(new TextDecoder(encoding, {fatal: true}).decode(bytes));
      });
      csvLoads.set(url, promise);
      promise.catch(() => csvLoads.delete(url));
    }
    return csvLoads.get(url);
  };
  const initCSV = () => {
    document.querySelectorAll('[data-lw-sizechart-csv]').forEach(async dialog => {
      if (dialog.dataset.lwCsvStarted) return;
      dialog.dataset.lwCsvStarted = 'true';
      try {
        const rows = await loadCSV(dialog.dataset.lwSizechartCsv);
        if (!dialog.isConnected) return;
        const table = document.createElement('table');
        table.className = 'lw-sizechart-table';
        const head = document.createElement('thead'), body = document.createElement('tbody');
        rows.forEach((values, index) => {
          const row = document.createElement('tr');
          if (index) row.dataset.lwSizechartSize = values[0];
          values.forEach((value, column) => {
            const cell = document.createElement(index === 0 || column === 0 ? 'th' : 'td');
            if (cell.tagName === 'TH') cell.scope = index === 0 ? 'col' : 'row';
            cell.textContent = value;
            row.appendChild(cell);
          });
          (index === 0 ? head : body).appendChild(row);
        });
        table.append(head, body);
        const host = dialog.querySelector('[data-lw-sizechart-csv-table]');
        host.replaceChildren(table);
        host.hidden = false;
        dialog.querySelector('[data-lw-sizechart-note]').hidden = false;
        document.querySelectorAll('[data-lw-sizechart-open]').forEach(trigger => {
          if (trigger.getAttribute('aria-controls') === dialog.id) trigger.hidden = false;
        });
      } catch (_) {
        delete dialog.dataset.lwCsvStarted;
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCSV, {once: true});
  else initCSV();
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('[data-lw-sizechart-csv]') || node.querySelector('[data-lw-sizechart-csv]'))))) initCSV();
  }).observe(document.documentElement, {childList: true, subtree: true});

  const openers = new WeakMap();
  const bindDialog = dialog => {
    if (dialog.dataset.lwBound) return;
    dialog.dataset.lwBound = 'true';
    dialog.addEventListener('close', () => {
      if (!document.querySelector('[data-lw-sizechart-dialog][open]')) {
        document.documentElement.classList.remove('lw-sizechart-open');
      }
      const opener = openers.get(dialog);
      if (opener?.isConnected) opener.focus();
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-lw-sizechart-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!dialog || dialog.open) return;
      event.preventDefault();
      bindDialog(dialog);
      openers.set(dialog, trigger);
      const group = trigger.closest('[data-option-position]');
      const selected = group?.querySelector('[data-selected-option]')?.textContent.trim().toLocaleLowerCase() || '';
      dialog.querySelectorAll('[data-lw-sizechart-size]').forEach(row => {
        row.classList.toggle('is-selected', !!selected && row.dataset.lwSizechartSize.toLocaleLowerCase() === selected);
      });
      document.body.appendChild(dialog);
      dialog.showModal();
      document.documentElement.classList.add('lw-sizechart-open');
      return;
    }
    const close = event.target.closest('[data-lw-sizechart-close]');
    if (close) close.closest('dialog')?.close();
  });
})();
